import React, { useEffect, useState } from "react";
import { Link, useLocation,  } from "react-router-dom";
import voiceEvacuation from '../../../../../src/assets/images/voice-evacuation.png';
import ASD from '../../../../../src/assets/images/ASD.png';
import aerosol from '../../../../../src/assets/images/aerosol.png';
import FireAlarm from '../../../../../src/assets/images/fire-alarm.png';
import cleanagent from '../../../../../src/assets/images/clean-agent.png';
import fireextinguisher from '../../../../../src/assets/images/fire-extinguisher.png';
import firehosecabinet from '../../../../../src/assets/images/fire-hose-cabinet.png';
import firewatertank from '../../../../../src/assets/images/fire-water-tank.png';
import foamsystem from '../../../../../src/assets/images/foam-system.png';
import kitchenhoodfs from '../../../../../src/assets/images/kitchen-hood.png';
import standpipe from '../../../../../src/assets/images/standpipe.png';
import firepump from '../../../../../src/assets/images/firepump.png';
import firehydrant from '../../../../../src/assets/images/fire-hydrant.png';
import fireprotect from '../../../../../src/assets/images/fireprotect.png';
import generator from '../../../../../src/assets/images/Generator.png';

import defaulr from '../../../../../src/assets/images/defaulr.jpeg';
import FormLayout from "../FormLayout";
import { useToast } from "../../../../Components/Others/ToastServices";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import Pagination from "../../../../Components/Utils/Pagenation";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import axiosInstance from "../../../../Services/axiosCommon";

const formImages = {
  "Fire Protection System - Summary": fireprotect,
  "Fire Pump": firepump,
  "Fire Water Tanks": firewatertank,
  "Fire / Foam Hose Cabinet": firehosecabinet,
  "Fire / Foam Hose Cabinet Details": firehosecabinet,
  "Fire Extinguisher": fireextinguisher,
  "Fire Extinguisher Details": fireextinguisher,
  "Clean Agent Fire Suppression System": cleanagent,
  "Fire Alarm System": FireAlarm,
  "Aspirating Smoke Detection System": ASD,
  "Asd System": ASD,
  "Voice Evacuation System /Pava": voiceEvacuation,
  "Stand Pipe Hose System": standpipe,
  "Foam Fire Suppression System": foamsystem,
  "Fire Hydrant": firehydrant,
  "Kitchen Hood Fire Suppression Sys.": kitchenhoodfs,
  "Aerosol Fire Suppression System": aerosol,
};

const defaultImage = defaulr;

function FormsIndex() {
   const [, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const toast = useToast();
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );

  const [FormType, setFormType] = useState([]);


  useEffect(() => {
    axiosInstance.get("/form/all-forms/with-category")
      .then((res) => {
        const enabledForms = res.data.data?.filter(form => form.enabled) || [];
        // enabledForms.push({ id: 2, name: "Generator", value: "generator", label: "Generator", enabled: true });
        // enabledForms.push({id: 3, name: "Fire", value: "fire", label: "Fire", enabled: true});

        setFormType(enabledForms);
        
        if (enabledForms.length > 0 && !activeTab) {
          setActiveTab(enabledForms[0].id);
          setParams(prev => ({
            ...prev,
            category: enabledForms[0].id
          }));
        }
      })
      .catch(console.error);
  }, []);



const [, setFormList] = useState([]);
const [, setLoading] = useState(false);


  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    category: "",
    
  });
  
  const { data, totalCount, getData, dataLoading,total } = UseGetDataSearch(
    "/form/all-forms",
   params
  );

  const handleTabClick = (formTypeValue) => {
  setActiveTab(formTypeValue);
  setParams((prev) => ({
    ...prev,
    category: formTypeValue,
    page: 1 
  }));
};


useEffect(() => {
  const fetchForms = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/form/all-forms", {
        params,
      });
      setFormList(response.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch forms", err);
    } finally {
      setLoading(false);
    }
  };

  if (params.category) {
    fetchForms();
  }
}, [params]);


  
 
  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);


  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, ] = useState([]);

  const handleMultiDelete = (data) => {
    axiosInstance
      .delete(`items/multi-delete`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: { ids: data },
      })
      .then((res) => {
        if (res.data?.status === true) {
          if (res?.data?.not_deleted_ids.length <= 0) {
            toast.open({
              type: "success",
              message: "Success",
              description: res.data?.msg || "Deleted Successfully.",
            });
            getData();
            setShowDelete(false);
          } else {
            toast.open({
              type: "warning",
              message: "Success",
              description:
                `${res.data?.msg} \n Some Products has dependenies` ||
                "Deleted Successfully.",
            });
            getData();
            setShowDelete(false);
          }
        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Delete UnSuccessfull",
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((err) => {
        console.error(err);
        toast.open({
          type: "error",
          message: "Error",
          description: "Network Error.",
        });
      });
  };

  console.log("Data", data);
  
   const [valueOfSearch,setValuesofSearch] = useState("")
     function searchFunction(e) {
   
       
       setValuesofSearch(e?.target?.value)
       setParams({ ...params, search: e?.target?.value, page:1 });
       setPage(1)
     }

       const [formData, setFormData] = useState({
         facilityName: '',
         facilityAddress: '',
         testType: 'Monthly',
         inspectorCertification: '',
         testDate: '',
         inspectorName: '',
         
         manufacturer: '',
         model: '',
         serialNumber: '',
         fuelType: 'Diesel',
         ratedPower: '',
         ratedVoltage: '',
         ratedFrequency: '',
         
         loadPercentage: '',
         runTime: '',
         oilPressure: '',
         coolantTemp: '',
         batteryVoltage: '',
         fuelLevel: '',
         
         voltageOutput: '',
         frequencyOutput: '',
         issuesFound: '',
         correctiveActions: '',
         nextTestDate: '',
         
         ambientTemperature: '',
         humidity: '',
         weatherConditions: 'Clear',
     
       generalCondition: "Good",
       corrosionPresent: false,
       leaksPresent: false,
       mountingSecure: false,
       ventilationAdequate: false,
     
       fuelLevel: "",
       fuelQuality: "Good",
       fuelFilterCondition: "Good",
       fuelPumpOperation: "Normal",
       fuelLinesSecure: false,

        inspectorName: "",
    startDate: "",
    endDate: "",
    totalDays: "",
    persons: "",
    serviceType: [],
    systemType: [],
    observation: "",
    actionTaken:"",
    qty:"",
    desc:"",
    person1:"",
    empcode:"",
    contactNo:"",
    date:"",
    person2:"",
    empcode1:"",
    contactNo1:"",
    date1:"",
       });
     
     
const [activeTab, setActiveTab] = useState("");

// After fetching FormType
useEffect(() => {
  if (FormType?.length > 0 && !activeTab) {
    const defaultCategory = FormType.find(f => f.enabled)?.label;
    setActiveTab(defaultCategory);
    setParams(prev => ({ ...prev, category: defaultCategory }));
  }
}, [FormType]);


const [, setCompliance] = useState({
    nfpa: true,
    localCode: true,
    manufacturer: true,
    notes: "",
  });

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCompliance((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
const rows = Array.from({ length: 10 }, (_, i) => i + 1); // 10 rows

  return (
    <>
    <FormLayout
            searchFun={searchFunction}
            searchValue={valueOfSearch}
                  total={totalCount}

    >
    <div className="w-full h-full  mt-0.5 ">
     
      <div className=" w-full h-[calc(100vh-180px)] bg-white  rounded-md overflow-hidden px-4 py-2">
        <div className=" w-full h-[calc(100vh-235px)] ">
         <div className="flex flex-wrap">
 {FormType?.filter(form => form.enabled).map((form) => (
  <button
    key={form.value}
    // onClick={() => handleTabClick(form.value)}
    onClick={() => {
        setActiveTab(form.label);
        setParams(prev => ({ ...prev, category: form.label, page: 1 }));
      }}
    className={`mx-3 mb-2 pb-1 text-xs 2xl:text-sm font-medium ${
      activeTab === form.label
        ? "text-baseColor-primary underline underline-offset-4 decoration-2"
        : "text-gray-500"
    }`}
  >
    {form.label}
  </button>
))}

</div>


<div className="w-full max-h-[calc(100vh-235px)] grid grid-cols-2 md:grid-cols-5 lg:grid-cols-7 gap-4 overflow-y-auto py-4">
  {/* Dynamic forms */}
  {data &&
  data.map((item, i) => (
    <Link
      key={i}
      to={
        item?.id === 20
          ? `/forms/insforms/fireProtect/view/20`
          : `/forms/insforms/view/${item?.id}`
      }
      state={{ data: item }}
      className="relative w-full h-auto bg-white text-[#111537] rounded-lg shadow-lg hover:shadow-xl transition-shadow"
    >
      {/* Badge */}
      <div className="h-[30px] w-full">
        <span className="absolute top-1 left-2 text-xs text-gray-500 border border-pageborder rounded-md p-1 w-5 h-5 flex items-center justify-center">
          {i + 1}
        </span>
      </div>

      {/* Content */}
      <div className="w-full h-auto flex flex-col py-1 px-2 justify-between items-center">
        <img
          src={formImages[item.formName] || defaultImage}
          alt={item.formName}
          className="w-16 h-16 object-contain"
          onError={(e) => {
            e.currentTarget.src = defaultImage;
          }}
        />
        <p className="line-clamp-3 text-xs text-center mt-2">
          {item?.formName || ""}
        </p>
      </div>
    </Link>
  ))}


  {/* Special Generator Card */}
  {activeTab === "generator" && (
    <Link
      to={`/forms/insforms/generatorForm/view/18`}
      className="relative w-full h-auto bg-white text-[#111537] rounded-lg shadow-lg hover:shadow-xl transition-shadow p-2"
    >
      {/* Badge */}
      <div className="h-[30px] w-full">
        <span className="absolute top-1 left-2 text-xs text-gray-500 border border-pageborder rounded-md p-1 w-5 h-5 flex items-center justify-center">
          18
        </span>
      </div>

      {/* Content */}
      <div className="w-full h-auto flex flex-col py-1 px-2 justify-between items-center">
        <img
          src={generator}
          alt="Generator Test Form"
          className="w-16 h-16 object-contain"
          onError={(e) => {
            e.currentTarget.src = defaultImage;
          }}
        />
        <p className="line-clamp-3 text-xs text-center mt-2">
          Generator Test Form
        </p>
      </div>
    </Link>
  )}

  {activeTab === "fire" && (
    <Link
      to={`/forms/insforms/fire/view/18`}
      className="relative w-full h-auto bg-white text-[#111537] rounded-lg shadow-lg hover:shadow-xl transition-shadow p-2"
    >
      {/* Badge */}
      <div className="h-[30px] w-full">
        <span className="absolute top-1 left-2 text-xs text-gray-500 border border-pageborder rounded-md p-1 w-5 h-5 flex items-center justify-center">
          18
        </span>
      </div>

      {/* Content */}
      <div className="w-full h-auto flex flex-col py-1 px-2 justify-between items-center">
        <img
          src={generator}
          alt="Fire Form"
          className="w-16 h-16 object-contain"
          onError={(e) => {
            e.currentTarget.src = defaultImage;
          }}
        />
        <p className="line-clamp-3 text-xs text-center mt-2">
          Fire Form
        </p>
      </div>
    </Link>
  )}
</div>



      {/* {
  activeTab === "fire" && (
      <div className="bg-white h-full w-full rounded-md flex flex-col overflow-y-auto p-4">
        <div className="bg-white rounded-lg p-6 mb-4 shadow-sm border border-gray-200">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">FIRE PROTECTION SYSTEM</h1>
          <h1 className="text-xl font-bold text-gray-800 mb-2">FIELD SERVICE REPORT</h1>

        </div>

         <div className="border p-3 rounded-md mt-3 text-gray-800">
          <h3 className="font-semibold text-xl mb-2 ">
          TECHNICIANS / INSPECTOR DETAILS 
        </h3>
        
     <div className="border border-gray-300 rounded-md text-sm mt-3">
  <table className="w-full border-collapse">
    <thead>
      <tr className="bg-red-100 text-center font-semibold">
        <th className="border border-gray-300 p-2">Name</th>
        <th className="border border-gray-300 p-2">Start Date</th>
        <th className="border border-gray-300 p-2">End Date</th>
        <th className="border border-gray-300 p-2">Total Days / Hours</th>
        <th className="border border-gray-300 p-2">No. of Persons</th>
      </tr>
    </thead>
    <tbody>
      <tr className="text-center">
        <td className="border border-gray-300 p-1">
          <input
            type="text"
            name="inspectorName"
            placeholder="Name"
            value={formData.inspectorName}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
        <td className="border border-gray-300 p-1">
          <input
            type="datetime-local"
            name="startDate"
            value={formData.startDate}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
        <td className="border border-gray-300 p-1">
          <input
            type="datetime-local"
            name="endDate"
            value={formData.endDate}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
        <td className="border border-gray-300 p-1">
          <input
            type="text"
            name="totalDays"
            placeholder="Total Days/Hours"
            value={formData.totalDays}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
        <td className="border border-gray-300 p-1">
          <input
            type="number"
            name="persons"
            placeholder="No. of Persons"
            value={formData.persons}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          />
        </td>
      </tr>
    </tbody>
  </table>
</div> 
</div>


      <div className="border p-3 rounded-md mt-3">
        <h3 className="font-semibold text-xl text-gray-800 mb-2">
          INSPECTION / SERVICE TYPE
        </h3>
        <div className="grid grid-cols-3 gap-2 text-sm text-gray-800">
          {[
            "Contractual",
            "Non-Contractual",
            "Comprehensive",
            "Semi-Comprehensive",
            "Non-Comprehensive",
            "Monthly",
            "Quarterly",
            "On Call",
            "Emergency Call",
            "Others",
            "Inspection",
            "General Service",
            "Repair Works",
            "New Installations",
          ].map((item) => (
            <label key={item} className="grid grid-cols-2 items-center ">
              {item}

              <input
                type="checkbox"
                checked={formData.serviceType.includes(item)}
                onChange={() => handleCheckboxChange("serviceType", item)}
              />
            </label>
          ))}
        </div>
      </div>

      <div className="border p-3 rounded-md mt-3 text-gray-800">
        <h3 className="font-semibold text-xl mb-2">TYPE OF SYSTEMS</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-sm">
          {[
            "Water Based Sprinkler System",
            "Foam Based Sprinkler System",
            "Stand Pipe & Hose System",
            "Deluge System",
            "Pre-Action System",
            "Fire Suppression System",
            "Fire Alarm System",
            "Fire Extinguishers",
            "Aspirating Smoke Detector System",
            "Emergency & Exit Light System",
            "Fire Hydrant",
            "Fire Pump",
            "Breeching Inlet / FDC",
            "Voice Evacuation System/PAVA",
            "Central Battery System",
            "Others",
          ].map((item) => (
            <label key={item} className="grid grid-cols-2 items-center">
              {item}

              <input
                type="checkbox"
                checked={formData.systemType.includes(item)}
                onChange={() => handleCheckboxChange("systemType", item)}
              />
            </label>
          ))}
        </div>
      </div>

      <div className="border p-3 rounded-md mt-3 text-gray-800">
        <h3 className="font-semibold text-xl mb-2">
          OBSERVATION / CUSTOMER COMPLAINT
        </h3>
        <textarea
          name="observation"
          value={formData.observation}
          onChange={handleInputChange}
          rows={5}
          className="w-full border rounded p-2 text-sm resize-none"
          placeholder="Enter observations or complaints here..."
        />
      </div>

      <div className="border p-3 rounded-md text-gray-800 mt-3">
        <h3 className="font-semibold text-xl mb-2">
           ACTION REQUIRED/TAKEN
        </h3>
        <textarea
          name="actionTaken"
          value={formData.actionTaken}
          onChange={handleInputChange}
          rows={5}
          className="w-full border rounded p-2 text-sm resize-none"
          placeholder="Enter here..."
        />
      </div>

<div className=" mt-5 text-gray-800">
  <h3 className="font-semibold text-xl mb-2">
           DAMAGES/REPLACEMENT /SPARE PARTS - DETAILS
        </h3>
        <div className="border border-gray-300 text-sm mt-3">
   
      
      <div className="grid grid-cols-12 border-b border-gray-300 font-semibold text-center bg-red-100">
        <div className="col-span-1 border-r border-gray-300 p-1">S.No.</div>
        <div className="col-span-9 border-r border-gray-300 p-1">Description</div>
        <div className="col-span-2 p-1">Qty</div>
      </div>

      {rows.map((row) => (
        <div
          key={row}
          className="grid grid-cols-12 border-b border-dotted border-gray-300 last:border-b-0 text-center"
        >
          <div className="col-span-1 border-r border-gray-300 p-1">{row}</div>
          <div className="col-span-9 border-r border-gray-300 p-1 text-cebter w-full"><input
          type="text"
          name="desc"
          placeholder="Enter Here.."
          value={formData.desc}
          onChange={handleInputChange}
          className="col-span-1 border rounded p-2 text-sm items-center w-full"
        /></div>
          <div className="col-span-2 p-1"><input
          type="number"
          name="qty"
          placeholder="Quantity"
          value={formData.qty}
          onChange={handleInputChange}
          className="col-span-1 border rounded p-2 text-sm"
        /></div>
        </div>
      ))}
    </div>
</div>

<div className="border border-gray-300 text-sm mt-5 text-gray-800">
 
  <div className="border-b border-gray-300 bg-red-100 text-gray-800 font-semibold text-xl text-center">
    <div className="p-1">ACKNOWLEDGEMENT</div>
  </div>

  <div className="grid grid-cols-6 border-b border-gray-300 font-semibold text-center text-gray-800">
    <div className="col-span-1 border-r border-gray-300 p-1 bg-red-50">For</div>
    <div className="col-span-1 border-r border-gray-300 p-1">Authorized Person</div>
    <div className="col-span-1 border-r border-gray-300 p-1">Employee Code</div>
    <div className="col-span-1 border-r border-gray-300 p-1">Contact No.</div>
    <div className="col-span-1 border-r border-gray-300 p-1">Date</div>
    <div className="col-span-1 p-1">Signature</div>
  </div>

  <div className="grid grid-cols-6 border-b border-gray-300 text-center">
    <div className="col-span-1 border-r border-gray-300 p-1 font-medium bg-red-50">
      Falcon Fire
    </div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="text"
            name="person1"
            placeholder="Name"
            value={formData.person1}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="text"
            name="empcode"
            placeholder="Employee Code"
            value={formData.empcode}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="number"
            name="contactNo"
            placeholder="Contact No."
            value={formData.contactNo}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="date"
            name="date"
            placeholder="date"
            value={formData.date}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 p-1"></div>
  </div>

  <div className="grid grid-cols-6 text-center">
    <div className="col-span-1 border-r border-gray-300 p-1 font-medium bg-red-50">
      Client
    </div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="text"
            name="person2"
            placeholder="Name"
            value={formData.person2}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="text"
            name="empcode1"
            placeholder="Employee Code"
            value={formData.empcode1}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="number"
            name="contactNo1"
            placeholder="Contact No."
            value={formData.contactNo1}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 border-r border-gray-300 p-1"><input
            type="date"
            name="date1"
            placeholder="date"
            value={formData.date1}
            onChange={handleInputChange}
            className="w-full p-1 text-sm border rounded"
          /></div>
    <div className="col-span-1 p-1"></div>
  </div>
</div>


        
</div>

  )} */}
        </div>
        
      </div>
    <div className=" w-full h-[40px] pb-4 bg-white">
          <Pagination
            page={page}
            setPage={setPage}
            totalCount={totalCount}
            pageCount={pageCount}
            setPageCount={setPageCount}
          />
        </div>
     
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => {
          handleMultiDelete(listofNumbers);
        }}
        closeModal={() => setShowDelete(false)}
      />

     
    </div>
    </FormLayout></>
  );
}

export default FormsIndex;
